module.exports = __webpack_public_path__ + "img/e787616.jpg";